var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.authLoading)?_c('div',{attrs:{"id":"loading-wrapper"}},[_c('img',{staticStyle:{"width":"168px"},attrs:{"id":"loading-text","src":require("@/assets/logo/Logo-Verde.png")}}),_c('div',{attrs:{"id":"loading-content"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }